import {Grid, IconButton} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import React from "react";

export function DialogCloseButton(props: {
  onClose: () => void,
}) {
  return (
    <Grid item={true} sx={{marginLeft: {xs: "auto", md: "0"}}}>
      <IconButton onClick={props.onClose} sx={{marginLeft: 2}}>
        <CancelIcon/>
      </IconButton>
    </Grid>
  )
}
